import React from 'react';
import { AppStore } from '../Core/AppStore';
import { Storage } from '../Core/Storage';
import { Helper } from '../Core/Helper';
import { CatalogueProvider } from '../Providers/CatalogueProvider';
import { Constants } from '../Core/Constants'


export default class VisitedProducts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			products: []
		};
	}

	componentDidMount = () => {
		var visited = Storage.instance().visitedProducts;

		if (visited && visited.length > 0) {
			if (visited > 9) visited = visited.slice(0, 9);
			CatalogueProvider.getProductByIds(visited, (data) => {
				this.setState({ products: data });
			});
		}

		if (!visited) visited = [];
		const productId = this.props.currentId;
		if (productId) {
			const idx = visited.indexOf(productId);
			if (idx >= 0) {
				visited.splice(idx, 1);
			}
			visited.unshift(productId);
			Storage.instance().visitedProducts = visited;

			//set utm_source for products
			const utmSource = Helper.getUrlPatram('utm_source');
			if (utmSource) {
				var productsUtmSource = Storage.instance().productsUtmSource ?? [];
				var foundIndex = productsUtmSource.findIndex(pus => pus.productId == productId);
				if (foundIndex < 0)
					productsUtmSource.push({ productId: productId, utmSource: utmSource });
				else
					productsUtmSource[foundIndex].utmSource = utmSource;
				Storage.instance().productsUtmSource = productsUtmSource;
			}
		}
	}

	getCount = (items) => {
		let count = 0;
		items.forEach((item) => {
			count = count + item.count;
		});
		return count;
	}

	componentDidUpdate = () => {
		if (this.state.products.length > 0) {
			this.$el = $(this.el);
			this.$el.owlCarousel({
				loop: true,
				margin: 10,
				nav: false,
				responsive: {
					0: {
						items: 4
					},
					700: {
						items: 6
					},
					850: {
						items: 7
					},
					1000: {
						items: 8
					}
				}
			});
		}
	}

	render() {
		let T = window.Texts.catalogue;
		const products = this.state.products;
		if (!products || products.length < 1)
			return <div />;
		return (
			<div className="viewed-products" id="app-viewed-products" dataGtmGaNavigation="viewed-products">
				<div className="cover">
					<div className="headline">
						<h4>{T.videliJste}</h4>
					</div>
					<div className="owlrow owl-carousel" ref={el => this.el = el}>
						{products.map((product) => {
							if (!product) return null;
							return (
								<div className="owlcol" key={product.id}>
									<a className="no-line" href={product.url}>
										<img src={product.thumb.url} className="img-responsive" alt={product.name} />
									</a>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		);
	}
}


//inicializace 
var element = document.getElementById("app-viewed-products");
if (element) {
	var currentId = element.getAttribute('currentId');
	var temp = document.createElement("div");
	ReactDOM.render(<VisitedProducts currentId={currentId} />, temp);

	var container = element.parentNode;
	// and replace the child
	if (temp.childNodes.length > 0) {
		container.replaceChild(temp.childNodes[0], element);
	}
	else {
		$(element).hide();
	}
}




